import { z } from "zod";
import { defineRoute } from "./http/route.js";
export const Health = z
    .object({
    status: z.enum(["ok", "degraded"]),
    checks: z.record(z.string(), z.enum(["ok", "failed"])),
})
    .meta({ id: "Health" });
export const health = defineRoute({
    id: "system.health.get",
    method: "GET",
    path: "/v1/health",
    surface: "tenant",
    auth: "none",
    permission: "none",
    marks: [],
    summary: "Liveness and dependency checks for load balancers and monitoring",
    responses: {
        200: { description: "Every dependency answered", schema: Health },
        503: { description: "At least one dependency failed", schema: Health },
    },
});
export const systemRoutes = [health];
//# sourceMappingURL=system.routes.js.map